/**
  * 接口域名的管理
  */
export const base = {
  production: 'https://passport.yqda.net/api/',
  development: 'https://passport.yqda.net/api/'
}

export const globalApiUrl = {
  CAPTCHA_URL: 'captcha',
  MSG_CODE_URL: 'msgcode',
  NEED_CAPTCHA_URL: 'iscaptcha'
}

export const userApiUrl = {
  LOGIN_URL: 'login',
  SECONDVERIFY_URL: 'secondverify',
  REFRESH_TOKEN_URL: 'refreshtoken',
  QQ_LOGIN_URL: 'login/qq',
  WEIXIN_LOGIN_URL: 'login/weixin',
  WEIBO_LOGIN_URL: 'login/weibo',
  REGISTER_URL: 'register',
  LOGOUT_URL: 'logout',
  FINDPWD_BYORDER_URL: 'findpwd/byorder',
  FINDPWD_BYPHONE_URL: 'findpwd/byphone',
  FINDPWD_VERIFY_URL: 'findpwd/step2',
  FINDPWD_RESET_URL: 'findpwd/step3',
  GET_USER_INFO_URL: 'user/getuser',
  BINDMOBILE_URL: 'user/bindmobile',
  BINDMAIL_URL: 'user/bindmail',
  UNBINDMAIL_URL: 'user/unbindmail',
  RESEND_MAIL_URL: 'user/resendmail',
  VERIFY_URL: 'user/verify',
  CHANGE_PASSWORD_URL: 'user/changepassword',
  GET_LOGIN_RECORD_URL: 'user/getloginrecord',
  UPLOADAVATAR_URL: 'user/uploadavatar',
  GET_ORDERS_URL: 'orders/list',
  GET_CARDS_URL: 'cards/list',
  GET_HISTORY_URL: 'user/history',
  GET_FAVLIST_URL: 'user/favlist'
}
